// extracted by mini-css-extract-plugin
export default {"page-title__stage":"_5DwSKySq","page-title__wrapper":"_5D1cHnMu","page-title__back-button":"_5D2rx-An","page-title":"_5D1juWZD","page-title__actions":"_5D2TocP-"};